<template>
  <div :class="{_invited: vacancy && vacancy.invited}"
       class="resume-active-responses__item">
    <div v-if="vacancy && vacancy.invited"
         class="resume-active-responses__invited-label">
      {{ $tResumePage('You are offered a job') }}
    </div>

    <ResumeActiveResponsesItemLabel v-if="vacancy"
                                    :vacancy="vacancy"/>

    <div class="d-flex">
      <div class="resume-active-responses__item-titles">
        <div v-if="vacancy"
             class="resume-active-responses__item-name-wrap">
          <router-link-modified :to="{name: 'vacancy', params: {vacancyId: vacancy.slug}}"
                                class="resume-active-responses__item-name">
            {{ $get(vacancy, '[1].name') }}
          </router-link-modified>
        </div>
        <ResumeActiveResponsesItemSalary v-if="vacancy"
                                         :section="vacancy[1]"/>
      </div>

      <ResumeMarkSelector
        v-if="isOur || isEmployer"
        :mark="$get(response, 'additional.mark')"
        :disabled="!response.can_edit"
        activator-size="5.1"
        class="mr-2"
        @input="onResumeMarkSet"
      />
      <ResumeConformityProgressMenu :match-data="matchData" moved-left>
        <template v-slot:activator>
          <ResumeConformityProgress
            v-if="isOur || isEmployer"
            :value="$get(response, 'additional.match')"
          />
        </template>
      </ResumeConformityProgressMenu>
    </div>
    <!--    <div class="resume-active-responses__item-subtitle">-->
    <!--      Работодатель-->
    <!--      <span class="resume-active-responses__item-subtitle-name">{{ employerProfile.name }}</span>-->
    <!--    </div>-->
    <div v-if="vacancy"
         class="resume-active-responses__item-row">
      <ResumeActiveResponsesItemLocation :section="vacancy[3]"/>
      <div class="resume-active-responses__viewed">
        <BaseSvg height="16px" width="16px" name="ico-eye"/>
        <span>
          {{ vacancy.views }}
        </span>
      </div>
    </div>
    <div class="resume-active-responses__item-footer">
      <div class="resume-active-responses__item-footer-item">
        <span class="resume-active-responses__item-footer-item-name">{{ $tResumePage('Sent') }} </span>
        <span>{{ formatNormalDate(response.sent_date) }}</span>
      </div>
      <template v-if="vacancy">
        <div v-if="vacancy.invited"
             class="resume-active-responses__item-footer-item">
          <span class="resume-active-responses__item-footer-item-name">{{ $tResumePage('Offer received') }} </span>
          <span v-if="response.invited_date">{{ formatNormalDate(response.invited_date) }}</span>
        </div>
        <div v-else
             class="resume-active-responses__item-footer-item">
          <span class="resume-active-responses__item-footer-item-name">{{
              $tResumePage('Waiting for an answer ...')
            }} </span>
        </div>
      </template>
    </div>
    <ResumeNote
      v-if="isOur || isEmployer"
      class="mt-4"
      :editable="response.can_edit"
      :author-name="$get(response, 'additional.note.customer')"
      :time="$get(response, 'additional.note.date')"
      :value="$get(response, 'additional.note.text')"
      @save="onNoteSave"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import {formatNormalDate} from '@/helpers/formatDate'
  import ResumeActiveResponsesItemLocation from './ResumeActiveResponsesItemLocation'
  import ResumeActiveResponsesItemSalary from './ResumeActiveResponsesItemSalary'
  import ResumeActiveResponsesItemLabel from './ResumeActiveResponsesItemLabel'
  import ResumeConformityProgress from '../resume-helpers/ResumeConformityProgress';
  import ResumeMarkSelector from '../resume-helpers/ResumeMarkSelector';
  import ResumeNote from '../resume-helpers/ResumeNote';
  import ResumeConformityProgressMenu from '../resume-helpers/ResumeConformityProgressMenu';

  export default {
    name: 'ResumeActiveResponsesItem',
    components: {
      ResumeConformityProgressMenu,
      ResumeNote,
      ResumeMarkSelector,
      ResumeConformityProgress,
      ResumeActiveResponsesItemLocation,
      ResumeActiveResponsesItemSalary,
      ResumeActiveResponsesItemLabel,
    },
    props: {
      response: Object
    },
    data(vm) {
      return {
        vacancy: vm.response.vacancy,
        employerProfile: vm.$get(vm.response.vacancy, 'employer.employerProfile', {}),
      }
    },
    computed: {
      ...mapGetters('user', [
        'isOur',
        'isEmployer'
      ]),

      matchData() {
        return this.response.additional?.match_array || {};
      },
    },
    methods: {
      formatNormalDate,

      ...mapActions('vacancies/responses', [
        'saveResponseNote',
        'setResumeMark',
      ]),

      async onResumeMarkSet(mark) {
        const resumeId = this.response.sent_resume_id;
        const success = await this.setResumeMark({ mark, resumeId });
        if (success) this.response.additional.mark = mark;
      },
      async onNoteSave({ value, callback }) {
        const { sent_resume_id } = this.response;

        const success = await this.saveResponseNote({ note: value, sent_resume_id });
        if (success) {
          this.response.additional.note = { text: value, customer: this.$tResumePage('I'), date: this.$tResumePage('now') };
          callback();
        }
      },
    }
  };
</script>
